import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import check from '@/components/check'
import record from '@/components/record'
import report from '@/components/report'

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/',name: 'index',component: index},
    {path: '/deviceCheck',name: 'check',component: check},
    {path: '/record',name: 'record',component: record},
    {path: '/report',name: 'report',component: report},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js